import { RiskScaleItem, RiskResidualItem, DEFAULT_RISK_SCALES, DEFAULT_RPS_SCALES } from "@/features/risks/entities/risk/model/risk.types"
import { v4 as uuid } from "uuid"
import { Establishment } from "../../establishment/model/establishment.types"
import { User } from "@/redux/user.types"

export const ORGANIZATION_ENTITY = "organization"

export interface Organization {
  id: string
  name: string
  establishmentId: string //siren
  // PHY scales
  severityScale: RiskScaleItem[]
  frequencyScale: RiskScaleItem[]
  preventionScale: RiskScaleItem[]
  residualRiskScale: RiskResidualItem[]
  // RPS scales
  rpsSeverityScale?: RiskScaleItem[]
  rpsFrequencyScale?: RiskScaleItem[]
  rpsPreventionScale?: RiskScaleItem[]
  rpsResidualRiskScale?: RiskResidualItem[]
  // Shared
  riskAttributes: string[]
  optionalRiskAttributes: string[]
  isMultiple: boolean
  AccountId: string
  Users: User[]
  Establishments: Establishment[]
}

/**
 * Crée une Organization vide, avec possibilité de surcharger les valeurs.
 */
export const createEmptyOrganization = (
  overrides?: Partial<Organization> & {
    users?: User[]
  }
): Organization => {
  const { severityScale, frequencyScale, preventionScale, residualRiskScale } = DEFAULT_RISK_SCALES
  const { severityScale: rpsSev, frequencyScale: rpsFreq, preventionScale: rpsPrev, residualRiskScale: rpsRes } = DEFAULT_RPS_SCALES

  // Deep copy PHY scales to avoid shared references
  const copySeverityScale = severityScale.map(s => ({ ...s }))
  const copyFrequencyScale = frequencyScale.map(s => ({ ...s }))
  const copyPreventionScale = preventionScale.map(s => ({ ...s }))
  const copyResidualScale = residualRiskScale.map(s => ({ ...s }))

  // Deep copy RPS scales (separate from PHY)
  const copyRpsSeverityScale = rpsSev.map(s => ({ ...s }))
  const copyRpsFrequencyScale = rpsFreq.map(s => ({ ...s }))
  const copyRpsPreventionScale = rpsPrev.map(s => ({ ...s }))
  const copyRpsResidualScale = rpsRes.map(s => ({ ...s }))

  return {
    id: uuid(),
    name: "",
    establishmentId: "",
    // PHY scales
    severityScale: copySeverityScale,
    frequencyScale: copyFrequencyScale,
    preventionScale: copyPreventionScale,
    residualRiskScale: copyResidualScale,
    // RPS scales - initialize with RPS-specific defaults
    rpsSeverityScale: copyRpsSeverityScale,
    rpsFrequencyScale: copyRpsFrequencyScale,
    rpsPreventionScale: copyRpsPreventionScale,
    rpsResidualRiskScale: copyRpsResidualScale,
    // Shared
    riskAttributes: [],
    optionalRiskAttributes: [],
    isMultiple: false,
    Establishments: [],
    AccountId: "",
    ...overrides,
    Users: []
  }
}
